import { useRef } from "react";
import { Button, IconButton } from "@mui/material";
import PopperMenu from "components/common/PopperMenu";
import { FolderInput } from "lucide-react";

export default ({
  menuOptions,
  isOpen,
  setIsOpen,
  onClickHandler,
  content = <FolderInput size={20} stroke="#6B6E7B" />,
}: {
  menuOptions: React.ReactElement | React.ReactElement[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onClickHandler?: () => void;
  content?: React.ReactElement | string;
}) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  return (
    <>
      {typeof content === "string" ? (
        <Button
          ref={anchorRef}
          onClick={() => {
            setIsOpen(!isOpen);
            onClickHandler?.();
          }}
          sx={(theme) => ({
            height: "38px",
            border: `1px solid ${theme.palette.border}`,
            borderRadius: "12px",
            width: "max-content",
            minWidth: "90px",
          })}
          variant="text"
        >
          {content}
        </Button>
      ) : (
        <IconButton
          ref={anchorRef}
          onClick={() => {
            setIsOpen(!isOpen);
            onClickHandler?.();
          }}
        >
          {content}
        </IconButton>
      )}
      <PopperMenu
        placement="bottom-end"
        open={isOpen}
        anchorRef={anchorRef}
        handleClose={() => {
          setIsOpen(false);
        }}
      >
        {menuOptions}
      </PopperMenu>
    </>
  );
};
